export default __webpack_public_path__ + "static/media/tech-blog.3b646fd5.png";